import React from "react";
import PropTypes from "prop-types";

import Rule from "@components/Rule";
import SideNote from "@components/SideNote";

import { css } from "@oddcommon/utils";
import styles from "./FreeformSection.module.scss";

export default function FreeformSection({
  title,
  description,
  ruleLabel,
  children,
  className,
  ...props
}) {
  return (
    <section className={css(styles.base, className)} {...props}>
      {(title || description || ruleLabel) && (
        <header>
          {ruleLabel && <Rule className={styles.rule}>{ruleLabel}</Rule>}
          {title && <h2>{title}</h2>}
          {/* Always here to provide margin in mobile layout */}
          <div className={styles.description}>{description}</div>{" "}
          {title && (
            <div className={styles.sideNoteContainer}>
              <SideNote>{title}</SideNote>
            </div>
          )}
        </header>
      )}
      {children}
    </section>
  );
}

FreeformSection.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  ruleLabel: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
